import { constants } from '@clubmed/utils';

import {
  ACTIVITIES_FACET_ID,
  CHILDCARE_FILTER_FACET_ID,
  DESTINATIONS_FACET_ID,
  FILTERABLE_FACETS_TEMPLATE_CONFIG,
  FLIGHT_DURATION_FACET_ID,
  SEASON_FACET_ID,
  TYPES_OF_STAY_FACET_ID,
} from 'Utils/faceting/constants';

const { NO_TRANSPORT_VALUE } = constants;

export const getFacetTemplateConfig = (
  criteriaContext: CriteriaContextValuesType,
  departureCity: string | null | undefined,
): Array<FacetTemplateConfig> => {
  const {
    displayActivityFilter,
    displayChildcareFilter,
    displayDestinationFilter,
    displayFlightDurationFilter,
    displaySeasonFilter,
    displayTypeOfStayFilter,
  } = criteriaContext;
  const enabledFilterIds = [
    displayActivityFilter ? ACTIVITIES_FACET_ID : null,
    displayChildcareFilter ? CHILDCARE_FILTER_FACET_ID : null,
    displayDestinationFilter ? DESTINATIONS_FACET_ID : null,
    displayFlightDurationFilter && departureCity && departureCity !== NO_TRANSPORT_VALUE
      ? FLIGHT_DURATION_FACET_ID
      : null,
    displaySeasonFilter ? SEASON_FACET_ID : null,
    displayTypeOfStayFilter ? TYPES_OF_STAY_FACET_ID : null,
  ];

  return FILTERABLE_FACETS_TEMPLATE_CONFIG.filter(({ id }) => enabledFilterIds.indexOf(id) !== -1);
};
